const enabled = (value) =>
  value === true || value === 1 || value === "1" || value === "true";

const hasOwn = (object, key) =>
  Object.prototype.hasOwnProperty.call(object || {}, key);

const normalizeProviders = (configuredProviders) => {
  const values = Array.isArray(configuredProviders)
    ? configuredProviders
    : typeof configuredProviders === "string"
      ? configuredProviders.split(",")
      : [];
  return values.reduce((providers, provider) => {
    const normalized = `${provider || ""}`.trim().toLowerCase();
    const canonical = normalized === "phone" ? "phone_otp" : normalized;
    if (
      ["email", "phone_otp", "apple", "google"].includes(canonical) &&
      !providers.includes(canonical)
    )
      providers.push(canonical);
    return providers;
  }, []);
};

export const getAuthCapability = ({
  settings = {},
  source = "web",
  user = null,
  slug = "",
} = {}) => {
  const orderPass = enabled(settings.enable_orderpass);
  const legacySocialAuth =
    enabled(settings.enable_social_auth) &&
    enabled(settings.enable_social_auth_staff) &&
    !orderPass;
  const canonicalMethodsProvided = hasOwn(settings, "checkout_auth_methods");
  const transitionalCapabilities =
    settings.storefront_auth_capabilities ||
    settings.checkout_auth_capabilities;
  const transitionalCapabilitiesProvided =
    transitionalCapabilities !== null &&
    transitionalCapabilities !== undefined;
  let providers = canonicalMethodsProvided
    ? normalizeProviders(settings.checkout_auth_methods)
    : legacySocialAuth && transitionalCapabilitiesProvided
      ? normalizeProviders(transitionalCapabilities)
      : [];

  if (
    !canonicalMethodsProvided &&
    !transitionalCapabilitiesProvided &&
    legacySocialAuth
  ) {
    if (slug !== "cinnabon-1") providers.push("email");
    if (enabled(settings.enable_phone_login)) providers.push("phone_otp");
    if (slug !== "cinnabon-1") providers.push("apple");
    if (
      slug !== "cinnabon-1" &&
      (source === "web" || enabled(settings.enable_google_login_on_app))
    )
      providers.push("google");
  }

  const canonicalRequirementProvided = hasOwn(
    settings,
    "require_account_at_checkout",
  );
  const loginRequired = canonicalRequirementProvided
    ? enabled(settings.require_account_at_checkout)
    : enabled(settings.require_customer_login) ||
      enabled(settings.disable_guest_checkout);
  const socialAuth = canonicalMethodsProvided
    ? providers.length > 0
    : legacySocialAuth;

  return {
    authenticated: !!user,
    enabled: providers.length > 0,
    orderPass,
    orderPassEnabled: orderPass,
    socialAuth,
    providers,
    guestAllowed: !loginRequired,
    loginRequired,
  };
};

export const canOpenAuthOverlay = (capability) =>
  !!capability?.enabled && !capability?.authenticated;
